export default __webpack_public_path__ + "static/our-tiny-home-nature-6aff4ddc256533713a57475fe864e360.png";